module.exports = __webpack_public_path__ + "img/enterprise_banner3.9ae74d4d.png";